import { Box, Flex } from '@chakra-ui/react'
import DsrConfirmationModal from '../../components/DsrConfirmationModal'
import { useState, useEffect } from 'react'
import { bindActionCreators } from 'redux'
import {
  changeDsrPageDisplay,
  setNewDsrDraftCurrentPage,
} from '../../actions/dsr-actions'
import { connect } from 'react-redux'
import { useParams, withRouter } from 'react-router-dom'
import DsrProspectDraftSideMenu from './DsrProspectDraftSideMenu'
import RenderDraftSubpageContent from '../../dsr-draft/RenderDraftSubpageContent'
import useChangeSubpageDisplay from '../../../global/hooks/change-subpage-display'


// Note: Render Dsr Content for DRAFT states
const RenderProspectDraftContent = ({
  changeDsrPageDisplay,
  selectedDisplaySubpage,
  pagesLocalState,
  replaceDsrPages,
  addDsrPage,
  removeDsrPage,
  selectedDisplayPageId,
  dsrPropertiesRedux,
  headerMenuHeight
}) => {
  const { pDsrId } = useParams()
  const [localState, setLocalState] = useState({
    showConfirmationModal: false,
    confirmationType: '',
  })

  const { handleSelectSubpage, clickCount } = useChangeSubpageDisplay();
  const [extraHeaderLayoutOffset, setExtraHeaderLayoutOffset] = useState(false)

  useEffect(() => {
    if (dsrPropertiesRedux.logoDisplayOption) {
      if (dsrPropertiesRedux.logoDisplayOption === "default") {
        !!extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(false)
      } else {
        !extraHeaderLayoutOffset && setExtraHeaderLayoutOffset(true)
      }
    }
  }, [dsrPropertiesRedux.logoDisplayOption]);

  useEffect(() => {
    if ((!selectedDisplayPageId && selectedDisplaySubpage === "overview-subpage" && pagesLocalState)) {
      changeDsrPageDisplay(pagesLocalState[0].pageId)
    }
  }, [selectedDisplayPageId, selectedDisplaySubpage, pagesLocalState])


  // Functions to change frontend local state of dsrPages
  const handleDisplayPageChange = (pageId, event) => {
    const updatedPages = pagesLocalState.map(page =>
      ((page.pageId === pageId) && event.target) ? ({ ...page, displayPage: event.target.checked }) : page
    )

    replaceDsrPages(updatedPages)
  }


  const handleConfirmationModalClose = () => {
    setLocalState((prevState) => ({
      ...prevState,
      showConfirmationModal: false,
      confirmationType: '',
    }))
  }


  return (
    <Flex className='dsr-content__section'>
      <Flex className='dsr-content__container'>
        <Flex direction="column" align="flex-start" w='100%' minHeight="40em">

          <Flex direction="row" align="flex-start" width="100%" height='100%'>
            <Flex display={['none', 'flex']} position='sticky' top={headerMenuHeight} bg="white">
              <DsrProspectDraftSideMenu
                pageArray={pagesLocalState}
                handleSelectSubpage={handleSelectSubpage}
                handleDisplayPageChange={handleDisplayPageChange}
                addNewDsrPage={addDsrPage}
                removeDsrPage={removeDsrPage}
                selectedDisplayPageId={selectedDisplayPageId}
                replaceDsrPages={replaceDsrPages}
                extraHeaderLayoutOffset={extraHeaderLayoutOffset}
                headerMenuHeight={headerMenuHeight}
              />
            </Flex>
            <Flex
              direction={['column', 'row']}
              justify="center"
              flexWrap="wrap"
              width="100%"
              bg='#F4F4F4'
              height='100%'
              pb='3em'
            >
              <Box 
                key={'page-view-' +clickCount}
                className="dsr-content__middle-column-container fade-in"
                transition="max-width 0.75s ease-in-out pt 0.75s ease-in-out"
                px="3em"
                pt={extraHeaderLayoutOffset && '2.5em'}
                maxWidth='900px'
                w='100%'
                mt='1em'
                >
            
                <RenderDraftSubpageContent
                  dsrPagesLocalState={pagesLocalState}
                  dsrId={pDsrId}
                  replacePages={replaceDsrPages}
                  dsrProperties={dsrPropertiesRedux}
                  extraHeaderLayoutOffset={extraHeaderLayoutOffset}
                  handleSelectSubpage={handleSelectSubpage}
                />
              </Box>
            </Flex>


            {/* // This section houses dynamically rendered components that depends on user journey */}
            {localState.showConfirmationModal && localState.confirmationType && (
              <DsrConfirmationModal
                // Logics
                confirmationType={localState.confirmationType} // Get from state to make this dynamic
                // Function
                handleCloseConfirmationModal={handleConfirmationModalClose}
              />
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}

const mapStateToProps = (state) => ({
  selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
  draftDsrCurrentPageRedux: state.dsrFeedContent.currentPage,
  dsrPropertiesRedux: state.draftDsrProperties.properties,
  selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeDsrPageDisplay,
      setNewDsrDraftCurrentPage
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RenderProspectDraftContent))
